import EnumLanguage from 'src/Locale/EnumLanguage';

export const getSupportedLanguages = () => [EnumLanguage.EN, EnumLanguage.DE, EnumLanguage.RU];

export const getSupportedLanguagesRegex = () => {
	return getSupportedLanguages().join('|');
};
